export default __webpack_public_path__ + "20a0a02deb05c33e687d58f9c5b53462.svg";